export const VIEW_MORE_MESSAGE = 'View More';
export const VIEW_LESS_MESSAGE = 'View Less';
